export default __webpack_public_path__ + "static/media/potentially.f9666d00.svg";